var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.dataset)?_c('div',[_c('span',{directives:[{name:"localize",rawName:"v-localize"}]},[_vm._v("No data")]),_vm._v(": "),_c('i',[_vm._v(_vm._s(_vm.props.dataset.misc_blurb))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }